










































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { getAppUrl } from '@/api/http-constants'
import { UserModule } from '@/store/modules/user'
import router from '../router'
import { getBoUrl } from '../api/http-constants'
import { ApiService } from '@/api/api.service'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/fr'
import cloneDeep from 'lodash/cloneDeep'
import take from 'lodash/take'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import { NotificationsModule } from '@/store/modules/notifications'

// On teste des variantes de in-app-nouveau-groupe-despace-partage-cree
function isGroupCreation(slug) {
    const words = slug.split(/-|\./)

    if (
        (words.includes('nouveau') && words.includes('groupe')) ||
        (words.includes('nouvel') && words.includes('espace')) ||
        (words.includes('groupe') && words.includes('cree')) ||
        (words.includes('espace') && words.includes('cree'))
    ) {
        return true
    }
    return false
}

function isCoffreFortEvent(slug) {
    const words = slug.split(/-|\./)
    return words.some(w =>
        ['identite', 'financement', 'lettre', 'achat', 'brs', 'document', 'coffre', 'dossier'].includes(w)
    )
}

function isPriceEvent(slug) {
    const words = slug.split(/-|\./)
    return words.some(w => ['prix', 'price', 'proposition', 'propose', 'tarif'].includes(w))
}

function isPlanEvent(slug) {
    const words = slug.split(/-|\./)
    return words.some(w => ['plan', 'blueprint', 'conception', 'esquisse'].includes(w))
}

dayjs.locale('fr')
dayjs.extend(relativeTime)

interface INotification {
    title: string
    type?: string
    date: Date
}

@Component({
    filters: {
        formatDate(value: string): string {
            return (dayjs() as any).to(dayjs(value))
        },
    },
    components: {
        SmoothReflow,
    },
})
export default class Notifications extends Vue {
    @Prop({ default: 'all' }) filter: string
    apiService = new ApiService()
    userID: number
    loaded = false

    get notifications() {
        return NotificationsModule.notifications
    }
    // notifications = [...Array(15).keys()].map(x => {
    //     return {
    //         createdAt: new Date(),
    //         notification: {
    //             mode: 'In-app',
    //             type: 'Utilisateur',
    //             title: 'Foo'
    //         },
    //     }
    // })

    get notificationsLoading() {
        return NotificationsModule.loading
    }

    get sortedNotifications() {
        if (!this.notifications) {
            return []
        }

        const sortedNotifications = cloneDeep(this.notifications)
        sortedNotifications.sort((a: any, b: any) => {
            const aDate = new Date(a.createdAt)
            const bDate = new Date(b.createdAt)
            return bDate.getTime() - aDate.getTime()
        })
        return sortedNotifications
    }

    get inAppNotifications() {
        return this.sortedNotifications.filter((notification: any) => {
            return notification.notification.mode === 'In-app'
        })
    }

    get notificationsWithOtherData() {
        return this.inAppNotifications.map((notification: any) => {
            let icon
            let route
            switch (notification.notification.type) {
                case 'Utilisateur':
                    icon = 'icon-user-color.png'
                    route = 'profile'
                    break
                case 'Groupe':
                    icon = 'icon-group-color.png'
                    route = 'groups'
                    break
                case 'Opération':
                    icon = 'icon-building-color.png'

                    const slug = notification.notification.slug
                    route = (() => {
                        // Coffre fort : validation ou refus d'un document
                        if (isCoffreFortEvent(slug)) {
                            return 'lock'
                        }

                        // Proposition de prix
                        if (isPriceEvent(slug)) {
                            return 'appart-recap'
                        }

                        // Plan générique / intégré disponible
                        if (isPlanEvent(slug)) {
                            return 'appart'
                        }

                        // Création d'un groupe d'espace partagé
                        if (isGroupCreation(slug)) {
                            return 'groups'
                        }

                        // Fallback : page accueil
                        return 'home'
                    })()
                    break
            }
            return {
                ...notification,
                icon,
                route,
            }
        })
    }

    get filteredNotifications() {
        return this.notificationsWithOtherData.filter(notification => {
            if (this.filter === 'all') {
                return true
            }

            let type
            switch (notification.notification.type) {
                case 'Utilisateur':
                    type = 'user'
                    break
                case 'Groupe':
                    type = 'groups'
                    break
                case 'Opération':
                    type = 'operations'
                    break
            }

            return type === this.filter
        })
    }

    get fiveNotifications() {
        return take(this.filteredNotifications, 15)
    }

    get slugs() {
        return this.inAppNotifications.map(
            notification => notification.notification.slug
        )
    }

    async created() {
        await NotificationsModule.InitNotifications()
        this.loaded = true
    }

    async openNotification(notification) {
        if (!notification.displayedAt) {
            await NotificationsModule.setNotificationAsDisplayed(notification)
        }
        this.$router.push({ name: notification.route })
    }
}
